import { TEMPLATE_LAYOUT } from "../constants/dashboard";
import { PAGINATION_OFFSET } from "../utils/general";
import { fetch, post, put } from "./base";

const userTemplateRoute = "user-templates";
const featuredTemplateRoute = "templates";
const getEndpoint = (isAdmin) =>
  `core/` + (isAdmin ? featuredTemplateRoute : userTemplateRoute);

const fetchTemplateCategories = async (cache = false) => {
  return fetch(`/core/categories`, { cache });
};
const videoTemplates = async (id, page = 0, search, offset, cache = false) => {
  // return fetch(`/uservedios/` + id + "/", { cache });
  return post(`/uservedios/` + id + "/", {
    offset: (page || 0) * PAGINATION_OFFSET,
    length: offset || PAGINATION_OFFSET,
    search: {
      value: search || "",
      regex: false,
    },
  });
};

const fetchFeaturedTemplates = async (
  page = 0,
  search,
  offset,
  layout = TEMPLATE_LAYOUT.HORIZONTAL,
  cache = true
) => {
  return post(`/core/templates/`, {
    offset: (page || 0) * PAGINATION_OFFSET,
    length: offset || PAGINATION_OFFSET,
    search: {
      value: search || "",
      regex: false,
    },
    layout,
  });
};

const fetchFeaturedTemplate = async (id) => {
  return fetch("/featuretemplate/" + id);
};

const removeTemplate = async (userId, id, isAdmin) => {
  const endpoint = getEndpoint(isAdmin);
  return fetch(endpoint + "/" + userId + "/" + id, {
    headers: {
      method: "delete",
    },
  });
};
const removeVideoTemplate = async (userId, id) => {
  return fetch("/delete_uservideo/" + userId + "/" + id, {
    headers: {
      method: "delete",
    },
  });
};

export const saveProjectTemplate = async (
  userId,
  data,
  isAdmin,
  cache = false
) => {
  const endpoint = getEndpoint(isAdmin);
  return post(`${endpoint}/` + userId + "/" + data.template_id + "/", {
    ...data,
    userId,
  });
};

export const updateVideoTemplate = async (userId, videoId, data) => {
  return put(`updatevideos/${userId}/${videoId}/`, data);
};
export const updateProjectTemplate = async (userId, data, isAdmin) => {
  const endpoint = getEndpoint(isAdmin);
  return put(`${endpoint}/${userId}/${data.template_id}/`, data);
};

export const getProjectDetails = async (id, cache = false) => {
  return fetch("core/templates/" + id + "/", { cache });
};

export const getNotification = async (id, cache = false) => {
  return fetch("/notifications", { cache });
};

const updateFavoriteTemplate = async (id, userId, isFavorite) => {
  const endpoint = isFavorite ? "add-to-favourite" : "remove-favourite";
  return post("/core/" + endpoint + "/" + userId + "/" + id + "/");
};

export const generateVideo = async (data, cache = false) => {
  return post("/generateVideo/", {
    ...data,
  });
};

export const generateSlideFrame = async (data, cache = false) => {
  return post("/generateSlideFrames/", {
    ...data,
  });
};
export const generateOnlyAvatarVideo = async (data, cache = false) => {
  return post("/generate_avatar_video/", {
    ...data,
  });
};

export {
  fetchTemplateCategories,
  fetchFeaturedTemplates,
  fetchFeaturedTemplate,
  removeTemplate,
  updateFavoriteTemplate,
  videoTemplates,
  removeVideoTemplate,
};
